@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.bankilyphonenumbers
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.DateTimeDto


class BankilyPhoneNumberDto(
    val id: KmmLong? = null,
    val driverId: KmmLong,
    val phone: String,
    val createdOn: DateTimeDto?,
)
